// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Record = require("../Record/index.js");
var Specular_FRP_Base = require("../Specular.FRP.Base/index.js");
var Specular_FRP_WeakDynamic = require("../Specular.FRP.WeakDynamic/index.js");
var Type_Data_RowList = require("../Type.Data.RowList/index.js");
var Type_Equality = require("../Type.Equality/index.js");
var FixFRPRecord = function (fixRecord) {
    this.fixRecord = fixRecord;
};
var FixFRP = function (fixFRP) {
    this.fixFRP = fixFRP;
};
var fixRecord = function (dict) {
    return dict.fixRecord;
};
var fixFRPRecordNil = function (dictTypeEquals) {
    return new FixFRPRecord(function (dictMonadFRP) {
        return function (v) {
            return function (f) {
                return Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(Data_Tuple.snd)(f(Type_Equality.to(dictTypeEquals)({})));
            };
        };
    });
};
var fixFRPRecord = function (dictFixFRPRecord) {
    return function (dictRowToList) {
        return new FixFRP(function (dictMonadFRP) {
            return fixRecord(dictFixFRPRecord)(dictMonadFRP)(Type_Data_RowList.RLProxy.value);
        });
    };
};
var fixFRP = function (dict) {
    return dict.fixFRP;
};
var fixFRPRecordCons = function (dictIsSymbol) {
    return function (dictLacks) {
        return function (dictCons) {
            return function (dictLacks1) {
                return function (dictCons1) {
                    return function (dictFixFRP) {
                        return function (dictFixFRPRecord) {
                            return new FixFRPRecord(function (dictMonadFRP) {
                                return function (v) {
                                    return function (f) {
                                        return fixFRP(dictFixFRP)(dictMonadFRP)(function (v1) {
                                            return fixRecord(dictFixFRPRecord)(dictMonadFRP)(Type_Data_RowList.RLProxy.value)(function (v2) {
                                                var ri = Record.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(v1)(v2);
                                                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(f(ri))(function (v3) {
                                                    var output = Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(v3.value0);
                                                    var tail_ro = Record["delete"](dictIsSymbol)()()(Data_Symbol.SProxy.value)(v3.value0);
                                                    return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(new Data_Tuple.Tuple(tail_ro, new Data_Tuple.Tuple(output, v3.value1)));
                                                });
                                            });
                                        });
                                    };
                                };
                            });
                        };
                    };
                };
            };
        };
    };
};
var fixFRP_ = function (dictFixFRP) {
    return function (dictMonadFRP) {
        return function (f) {
            return fixFRP(dictFixFRP)(dictMonadFRP)(function (input) {
                return Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(function (x) {
                    return new Data_Tuple.Tuple(x, Data_Unit.unit);
                })(f(input));
            });
        };
    };
};
var fixEvent = function (dictMonadFRP) {
    return function (f) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (v) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(f(v.event))(function (v1) {
                return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(v.fire)(v1.value0))(function () {
                    return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(v1.value1);
                });
            });
        });
    };
};
var fixFRPEvent = new FixFRP(function (dictMonadFRP) {
    return fixEvent(dictMonadFRP);
});
var fixDyn = function (dictMonadFRP) {
    return function (f) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (v) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_WeakDynamic.holdWeakDyn(dictMonadFRP)(v.event))(function (wdyn) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(f(wdyn))(function (v1) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(v.fire)(v1.value0))(function () {
                        return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(v1.value1);
                    });
                });
            });
        });
    };
};
var fixFRPDynamic = new FixFRP(function (dictMonadFRP) {
    return fixDyn(dictMonadFRP);
});
module.exports = {
    fixDyn: fixDyn,
    fixEvent: fixEvent,
    FixFRP: FixFRP,
    fixFRP: fixFRP,
    fixFRP_: fixFRP_,
    FixFRPRecord: FixFRPRecord,
    fixRecord: fixRecord,
    fixFRPEvent: fixFRPEvent,
    fixFRPDynamic: fixFRPDynamic,
    fixFRPRecord: fixFRPRecord,
    fixFRPRecordNil: fixFRPRecordNil,
    fixFRPRecordCons: fixFRPRecordCons
};
//# sourceMappingURL=index.js.map
